"use strict";

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var state_1 = require("../default/state");

var Html5VideoHtmlRenderer = function Html5VideoHtmlRenderer(_a) {
  var _b = _a.state,
      _c = (_b === void 0 ? state_1.defaultHtml5VideoState : _b).url,
      url = _c === void 0 ? '' : _c;
  return React.createElement("video", {
    autoPlay: true,
    controls: true,
    loop: true,
    muted: true,
    width: "100%",
    key: url
  }, React.createElement("source", {
    src: url,
    type: "video/" + url.split('.').pop()
  }));
};

exports.default = Html5VideoHtmlRenderer;